<template>
    <div class="w-full h-[600vw] relative flex justify-center">
        <img src="../../assets/img/Mobile/Present/line back gift.webp" alt="" class="w-full h-auto absolute mt-[15vw]">
        <img src="../../assets/img/Mobile/Present/star back gift.webp" alt="" class="w-full h-auto absolute mt-[45vw]">
        <div class="absolute top-[50vw] left-0 pl-[15vw]">
            <p class="text-white font-lemajor text-[24vw] text-glow">N</p>
            <p class="text-white font-lemajor w-[80vw] text-[13.5vw] text-glow lead absolute top-[2vw] left-[33vw]">
                ina
            </p>
            <p class="text-white font-thin text-[7.44vw] font-josefin-italic w-[80vw] absolute top-[18vw] left-[33vw]">
                PRESENT A GIFT
            </p>
        </div>

        <div class="absolute top-[86vw] w-[95vw] z-30">
            <!-- VIETNAMESE -->
            <!-- <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light">
                Tất cả những điều tôi đang làm không hướng đến sự nổi tiếng hay trục lợi cá nhân. Sự thật là từ rất lâu,
                tôi đã không đặt hai thứ này lên ưu tiên và cũng không chạy theo chúng, bởi có rất nhiều người trong xã
                hội đã và đang làm điều đó. Tôi hướng đến điều gì thì chỉ mình tôi biết. Tôi thậm chí đã lên kế hoạch
                cho một ngày X ngày mà tôi sẽ xoá hết tất cả mọi thứ về bản thân trên mạng xã hội.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[2.32vw]">
                Tôi không muốn quá nhiều người biết đến mình hay quen với sự tồn tại của tôi quá lâu. Thứ còn lại có thể
                chỉ là một cảm xúc, một loại cảm giác vừa dữ dội vừa nhẹ nhàng truyền từ tai lên não – cách mọi người
                truyền tai nhau, hoặc một cuốn truyện/sách tôi để lại sau này.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[2.32vw]">
                Khi bạn già đi, có thể bạn sẽ chỉ nhớ mang máng rằng đã từng có một cô gái như vậy, lướt qua tầm mắt của
                cuộc đời bạn trong một khoảng thời gian nhất định. Cô ấy giống như bước ra từ trong sách, từ những ngọn
                gió, từ những ý niệm, một người con gái kỳ lạ nhất mà bạn từng biết, dù chỉ qua mạng. Bạn mơ hồ tự hỏi
                liệu cô ấy có thật sự là người thật hay không, nhưng bạn sẽ tin rằng trên thế gian này, điều kỳ diệu là
                có thật.
            </p>

            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[12.32vw]">
                Nếu bạn thích con đường của tôi và muốn ủng hộ tôi nhiều hơn về mặt cá nhân, chúng tôi luôn hoan nghênh
                và trân trọng
                các khoản đóng góp.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]">
                Nếu bạn ở đây, điều đó có nghĩa là bạn theo dõi tôi trên phương tiện truyền thông xã hội của tôi.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]">
                Tôi mãi mãi biết ơn bạn.<br />Mỗi khi bạn xem video, phim ngắn, thích, chia sẻ, bình luận, theo dõi tôi
                trên
                phương tiện truyền thông xã hội và đặt dịch vụ của tôi, bạn giúp tôi phát triển đế chế nhỏ bé của mình
                ngày càng nhiều hơn.<br />Mọi thứ tôi làm, tôi làm vì bạn và vì bạn.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]">
                Nếu không có bạn, sẽ không có tôi.<br/>Tôi không có nhà cố định, tôi di chuyển nhiều nơi theo tiếng gọi của
                trái tim & tâm linh bên trong tôi.<br/>Tôi đã là một người hành hương tìm kiếm phép thuật và kiến thức cổ
                xưa trong nhiều năm. Đôi khi, tôi cảm thấy cô đơn, nhưng tất cả những gì tôi cần làm là đọc bình luận
                của bạn hoặc nhận ra rằng bạn đang theo dõi và làm theo những gì tôi tạo ra và đưa ra thế giới. Bạn có
                khả năng chạm đến trái tim tôi và trao cho tôi tình yêu và lòng tốt của bạn bất kể chúng ta ở đâu trên
                hành tinh này.<br/>Bạn luôn nhắc nhở tôi rằng tôi không bao giờ đơn độc, và dù tôi đi đâu, bạn sẽ luôn theo
                tôi.
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]">
                Cảm ơn bạn từ tận đáy lòng vì tình yêu, sự kỳ diệu, sự ủng hộ và vẻ đẹp của bạn.
            </p> -->

            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light" v-html="t('presentMobile.paragraphs[0]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[2.32vw]" v-html="t('presentMobile.paragraphs[1]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[2.32vw]" v-html="t('presentMobile.paragraphs[2]')">
            </p>

            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[12.32vw]" v-html="t('presentMobile.paragraphs[3]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]" v-html="t('presentMobile.paragraphs[4]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]" v-html="t('presentMobile.paragraphs[5]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]" v-html="t('presentMobile.paragraphs[6]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-josefin-italic font-light pt-[7vw]" v-html="t('presentMobile.paragraphs[7]')">
            </p>
            <p class="text-white text-[4.18vw] leading-[7vw] font-lemajor font-light pt-[7vw]">
                _NiNawitch_
            </p>
        </div>

        <img src="../../assets/img/Mobile/Present/smoke gift traí.webp" alt=""
            class="w-[100vw] absolute top-[60vw] left-0">
        <img src="../../assets/img/Mobile/Present/smoke gift phải.webp" alt=""
            class="w-full absolute bottom-[70vw] right-0">
        <div class="w-full h-auto absolute bottom-0 z-10">
            <img src="../../assets/img/Mobile/Present/qr code.webp" alt="" class="w-full h-auto">
            <div class="absolute text-white font-lemajor text-[6vw] top-[30vw] left-[2.5vw] leading-[12vw]" v-html="t('presentMobile.qrMessage')">
            </div>
        </div>
    </div>
    <FooterMobile />
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import FooterMobile from './FooterMobile.vue';

const { t } = useI18n();
</script>


<style scoped>
.font-lemajor {
    font-family: "TP Le Major", sans-serif;
}

.font-josefin-normal {
    font-family: "JosefinNormal", sans-serif;
}

.font-josefin-italic {
    font-family: "JosefinItalic", sans-serif;
}

.text-glow {
    text-shadow: 0px 0px 4vw rgba(255, 255, 255, 0.50);
}
</style>